export const UNSTARTED = "unstarted";
export const CONNECTED = "connected";
export const DISCONNECTED = "disconnected";
export const RECONNECTING = "reconnecting";
export const RECONNECTED = "reconnected";
